module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chatMessage"
  }, [(!_vm.openDetail) ? _c('div', {
    staticClass: "entrance",
    on: {
      "click": function($event) {
        _vm.openDetail = true
      }
    }
  }, [(_vm.unreadMessageNum > 0) ? _c('span', [_vm._v(_vm._s(_vm.unreadMessageNum))]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./img/entrance.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.openDetail) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(0), _vm._v(" "), (_vm.unreadMessageNum) ? _c('span', [_vm._v(_vm._s(_vm.unreadMessageNum))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    attrs: {
      "type": "text",
      "placeholder": "搜索"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        _vm.openDetail = false
      }
    }
  }, [_vm._v("")])])]), _vm._v(" "), (_vm.searchText === '') ? _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.contactData), function(v, i) {
    return (!v.ishide) ? _c('div', {
      key: i,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "label",
      on: {
        "click": function($event) {
          v.expand = !v.expand
        }
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('em', {
      staticClass: "icon_v3",
      class: {
        'expand': v.expand
      }
    }, [_vm._v("")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(v.label))])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_vm._v(_vm._s(("(" + (v.onlineNum) + "/" + (v.list.length) + ")")))])]), _vm._v(" "), (v.expand) ? _c('div', {
      staticClass: "list"
    }, _vm._l((v.list), function(m, n) {
      return _c('div', {
        key: n,
        staticClass: "item",
        on: {
          "dblclick": function($event) {
            _vm.dialogCurrent.inviteCode != m.inviteCode && _vm.openDialog(m, i)
          }
        }
      }, [_c('div', {
        staticClass: "left"
      }, [_c('img', {
        attrs: {
          "src": _vm.chooseHeanderImg(m),
          "alt": ""
        }
      }), _vm._v(" "), _c('div', [(i == 0) ? _c('span', {
        staticClass: "name"
      }, [_vm._v("我的上级")]) : _c('span', {
        staticClass: "name"
      }, [_vm._v(_vm._s(m.cn))]), _vm._v(" "), _c('span', {
        staticClass: "lastText",
        domProps: {
          "innerHTML": _vm._s(_vm.lastMessage(m))
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "right"
      }, [(m.lastMessage) ? _c('span', {
        staticClass: "time"
      }, [_vm._v(_vm._s(_vm.filter_time(m.lastMessage.createTime)))]) : _vm._e(), _vm._v(" "), (m.unReadCount > 0) ? _c('span', {
        staticClass: "unread"
      }, [_vm._v(_vm._s(m.unReadCount))]) : _vm._e()])])
    }), 0) : _vm._e()]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), (_vm.searchText !== '') ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.searchList), function(m, n) {
    return _c('div', {
      key: n,
      staticClass: "item",
      on: {
        "dblclick": function($event) {
          _vm.dialogCurrent.inviteCode != m.inviteCode && _vm.openDialog(m)
        }
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('img', {
      attrs: {
        "src": _vm.chooseHeanderImg(m),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(m.cn))]), _vm._v(" "), _c('span', {
      staticClass: "lastText",
      domProps: {
        "innerHTML": _vm._s(_vm.lastMessage(m))
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [(m.lastMessage) ? _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.filter_time(m.lastMessage.createTime)))]) : _vm._e(), _vm._v(" "), (m.unReadCount > 0) ? _c('span', {
      staticClass: "unread"
    }, [_vm._v(_vm._s(m.unReadCount))]) : _vm._e()])])
  }), 0)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "newMessagePrompt"
  }, _vm._l((_vm.newMessage), function(v, i) {
    return _c('div', {
      key: i,
      staticClass: "item",
      class: v.unReadCount ? 'show' : 'hide',
      on: {
        "click": function($event) {
          _vm.openDialog(v), _vm.newMessageRead(i)
        }
      }
    }, [(v) ? _c('img', {
      attrs: {
        "src": _vm.chooseHeanderImg(v),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("收到新消息")])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogBoxShow),
      expression: "dialogBoxShow"
    }],
    staticClass: "dialogBox",
    class: {
      'hasChatRecord': _vm.chatRecordShow
    }
  }, [_c('div', {
    staticClass: "dialogBoxList"
  }, _vm._l((_vm.dialogBoxList), function(v, i) {
    return _c('div', {
      key: i,
      staticClass: "item",
      class: {
        'active': v.inviteCode == _vm.dialogCurrent.inviteCode
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeDislog(v)
        }
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('img', {
      attrs: {
        "src": _vm.chooseHeanderImg(v),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [(!_vm.istopProxy) ? _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(v.cn))]) : _c('div', {
      staticClass: "name"
    }, [_vm._v("我的上级")]), _vm._v(" "), _c('div', {
      staticClass: "lastMessage"
    }, [_vm._v(_vm._s(_vm.lastMessage(v)))])]), _vm._v(" "), _c('div', {
      staticClass: "itemClose"
    }, [_c('em', {
      staticClass: "icon_v3",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleteDialogItem(v, i)
        }
      }
    }, [_vm._v("")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dialogBoxContent"
  }, [_c('div', {
    staticClass: "top",
    on: {
      "mousedown": function($event) {
        _vm.canDrag = true
      },
      "mousemove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.dragMove($event)
      },
      "mouseup": function($event) {
        return _vm.dragEnd($event)
      },
      "mouseleave": function($event) {
        return _vm.dragEnd($event)
      }
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.chooseHeanderImg(_vm.dialogCurrent),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [(!_vm.istopProxy) ? _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.dialogCurrent.cn))]) : _c('span', {
    staticClass: "name"
  }, [_vm._v("我的上级")]), _vm._v(" "), _c('span', {
    staticClass: "offline",
    class: _vm.dialogCurrent.isOnline ? 'online' : ''
  }, [_vm._v(_vm._s(_vm.dialogCurrent.isOnline ? '在线' : '离线'))])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        return _vm.closeAllMessage()
      }
    }
  }, [_vm._v("")])])]), _vm._v(" "), _c('div', {
    staticClass: "messageList",
    attrs: {
      "id": "messageList"
    }
  }, _vm._l((_vm.messageList), function(v, i) {
    return _c('div', {
      key: i,
      staticClass: "item"
    }, [(i == 0 || _vm.messageDateShow(i, _vm.dialogCurrent.messageList)) ? _c('div', {
      staticClass: "date"
    }, [_vm._v("\n            " + _vm._s(_vm.messageDate(v.createTime)) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      class: v.isSelf ? 'messageSend' : 'messageReceive'
    }, [_c('div', {
      staticClass: "photo"
    }, [_c('img', {
      attrs: {
        "src": v.isSelf ? _vm.headerImg['self'] : _vm.chooseHeanderImg(_vm.dialogCurrent),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('span', {
      staticClass: "tri"
    }), _vm._v(" "), _c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(v.text ? v.text.replace(/\n/g, '<br/>') : '')
      }
    })])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "tool"
  }, [_c('div', {
    staticClass: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "right",
    on: {
      "click": function($event) {
        return _vm.openRecord()
      }
    }
  }, [_vm._m(2), _vm._v("聊天记录")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.writeData),
      expression: "writeData"
    }],
    staticClass: "text",
    attrs: {
      "autofocus": "",
      "placeholder": "请输入聊天内容",
      "readonly": _vm.sending
    },
    domProps: {
      "value": (_vm.writeData)
    },
    on: {
      "keydown": function($event) {
        if (!$event.ctrlKey) { return null; }
        _vm.ctrlIsDown = true
      },
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 17) { return null; }
        return _vm.ctrlKeyup()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if (!$event.ctrlKey) { return null; }
        return _vm.newline()
      }],
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        !_vm.sendMessage(_vm.writeData)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.writeData = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.websocketStatus),
      expression: "!websocketStatus"
    }],
    staticClass: "reLink"
  }, [_vm._v("重新链接中...")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('span', {
    staticClass: "end",
    on: {
      "click": function($event) {
        return _vm.closeMessage()
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('span', {
    staticClass: "send",
    on: {
      "click": function($event) {
        return _vm.sendMessage()
      }
    }
  }, [_vm._v("发送")])])])]), _vm._v(" "), (_vm.chatRecordShow) ? _c('div', {
    staticClass: "chatRecord"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', [_vm._v("聊天记录")]), _vm._v(" "), _c('em', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        return _vm.closeChatRecord()
      }
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "chatRecordContent",
    attrs: {
      "id": "chatRecordContent"
    }
  }, _vm._l((_vm.chatRecordList), function(v, i) {
    return _c('div', {
      key: i,
      staticClass: "item",
      class: 'item' + v.id
    }, [(i == 0 || _vm.messageDateShow(i, _vm.chatRecordList)) ? _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.messageDate(v.createTime)))]) : _vm._e(), _vm._v(" "), _c('div', {
      class: v.isSelf ? 'messageSend' : 'messageReceive'
    }, [_c('div', {
      staticClass: "photo"
    }, [_c('img', {
      attrs: {
        "src": v.isSelf ? _vm.headerImg['self'] : _vm.chooseHeanderImg(_vm.dialogCurrent),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('span', {
      staticClass: "tri"
    }), _vm._v(" "), _c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(v.text ? v.text.replace(/\n/g, '<br/>') : '')
      }
    })])])])
  }), 0)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_c('img', {
    attrs: {
      "src": "/static/img/chartnotice.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_c('img', {
    attrs: {
      "src": "/static/img/chartserch.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_c('img', {
    attrs: {
      "src": "/static/img/chartList.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1f8a8677"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/chatMessage/chatMessage.vue
// module id = 887
// module chunks = 9